module.exports = __webpack_public_path__ + "img/4.76b5e664.jpg";